import { RequestInstance } from "../../utils/request";

export const estateList = new RequestInstance({
  method: "get",
  url: "/v2/estate/list",
});

export const estateTree = new RequestInstance({
  method: "get",
  url: "/v2/estate/tree",
});

export const estateAdd = new RequestInstance({
  method: "post",
  url: "/v2/estate/add",
});

export const estateUpdate = new RequestInstance({
  method: "post",
  url: "/v2/estate/update",
});

export const estateDelete = new RequestInstance({
  method: "post",
  url: "/v2/estate/delete",
});

export const floorAdd = new RequestInstance({
  method: "post",
  url: "/v2/floor/add",
});

export const floorUpdate = new RequestInstance({
  method: "post",
  url: "/v2/floor/update",
});

export const floorDelete = new RequestInstance({
  method: "post",
  url: "/v2/floor/delete",
});

export const roomAdd = new RequestInstance({
  method: "post",
  url: "/v2/room/add",
});

export const roomUpdate = new RequestInstance({
  method: "post",
  url: "/v2/room/update",
});

export const roomDelete = new RequestInstance({
  method: "post",
  url: "/v2/room/update",
});

export const roomDevicePage = new RequestInstance({
  method: "get",
  url: "/v2/room/device/page",
});

export const roomDeviceDelete = new RequestInstance({
  method: "post",
  url: "/v2/room/device/delete",
});

export const roomDeviceUnboundList = new RequestInstance({
  method: "get",
  url: "/v2/room/device/unbound/list",
});

export const roomDeviceUpdate = new RequestInstance({
  method: "post",
  url: "/v2/update/room/device",
});

export const roomDeviceList = new RequestInstance({
  method: "get",
  url: "/v2/room/device/list",
});
export const collDeviceList = new RequestInstance({
  method: "get",
  url: "/v2/deviceList",
});

export const deviceClientList = new RequestInstance({
  method: "get",
  url: "/v2/device/client/list",
});

export const bindDeviceList = new RequestInstance({
  method: "get",
  url: "/v2/device/client/list",
});

export const fileInfoRemove = new RequestInstance({
  method: "post",
  url: "/v2/file/info/remove_by_id",
});

export const fileListResource = new RequestInstance({
  method: "get",
  url: "/v2/file/list/by/resource",
});
